$(document).on("click", ".question_product,.faq_question,.footer_menu_1 p, .footer_menu_2 p", function (e) {
  if (jQuery(this).hasClass("active")) {
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
  } else {
    jQuery('.question_product,.faq_question,.footer_menu_1 p, .footer_menu_2 p').removeClass('active');
    jQuery('.question_product,.faq_question,.footer_menu_1 p, .footer_menu_2 p').next().slideUp();
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
  }
});

$(document).on("click", ".custom_button", function (e) {
     var video = jQuery(this).parents('.video_wrapper_custom').find('video');
 if (jQuery(this).hasClass("active")) {
    jQuery(this).parents('.video_wrapper_custom').removeClass('video-active');
     jQuery(this).removeClass('active');
 video.trigger('pause');
 } else {
 video.trigger('play');
   jQuery(this).parents('.video_wrapper_custom').addClass('video-active');
     jQuery(this).addClass('active');
 }
 });






// $(document).on("click", ".custom_button", function (e) {
//     var video = jQuery(this).parents('.video_wrapper_custom').find('video');
// if (jQuery(this).hasClass("active")) {
//    jQuery(this).parents('.video_wrapper_custom').removeClass('video-active');
//     jQuery(this).removeClass('active');
// video.trigger('pause');
// } else {
// video.trigger('play');
//   jQuery(this).parents('.video_wrapper_custom').addClass('video-active');
//     jQuery(this).addClass('active');
// }
// });







$(document).on("click", "a[href='#compare']", function (e) {
  e.preventDefault();
  document.querySelector('#compare').scrollIntoView({
    behavior: 'smooth'
  })
});

$(document).on("click", "a[href='#reviews']", function (e) {
  e.preventDefault();
  document.querySelector('#reviews').scrollIntoView({
    behavior: 'smooth'
  })
});

$(document).on("click", "a[href='#faq']", function (e) {
  e.preventDefault();
  document.querySelector('#faq').scrollIntoView({
    behavior: 'smooth'
  })
});

$(document).on("click", "a[href='#']", function (e) {
  e.preventDefault();
  document.querySelector('.landing_product_info').scrollIntoView({
    behavior: 'smooth'
  })
});

$(document).on("click", ".custom_checkout_button.custom_hk_button[disabled]", function (e) {
  e.preventDefault();
  document.querySelector('.custom_select_box').scrollIntoView({
    behavior: 'smooth'
  })
});



jQuery(document).ready(function(){
if(navigator.userAgent.indexOf('Mac') > 0) {
jQuery('body').addClass('mac-os');
} else {
jQuery('body').addClass('window-os');
}
});

function isScrolledIntoView(elem) {
    var docViewTop = $(window).scrollTop();
    var docViewBottom = docViewTop + $(window).height();

    var elemTop = $(elem).offset().top;
    var elemBottom = elemTop + $(elem).height();

    return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
}

$(window).scroll(function () {
    $('.custom_counter .icons_with_text_flex').each(function () {
      var this_element =  $(this);
      if (this_element.hasClass("start_count")) {
} else {
        if (isScrolledIntoView(this) === true) {
            this_element.addClass('start_count');
$('.start_count .count_js').each(function () {
    $(this).prop('Counter', 0).animate({
            Counter: $(this).data('value')
        }, {
        duration: 2000,
        easing: 'swing',
        step: function (now) {                      
            $(this).text(Math.ceil(now));
        }
    });
});
        }
      }
    });

});



$(document).on("click", ".tab_item_pdp", function (e) {
var data_tab = $(this).attr('data_tab');
$('.tab_item_pdp').removeClass('active');
$(this).addClass('active');
$('.tab_content_pdp').hide();
$('.tab_content_pdp[data_tab="'+data_tab+'"]').show();
});


function isScrolledIntoView2(elem) {
    var docViewTop = $(window).scrollTop();
    var docViewBottom = docViewTop + $(window).height();
docViewBottom = docViewBottom-($(window).height()/2)+($(elem).height())+200;
    var elemTop = $(elem).offset().top;
    var elemBottom = elemTop + $(elem).height();

    return ((elemBottom <= docViewBottom));
}

$(window).scroll(function () {
    $('.step_list .icons_with_text_item').each(function () {
        if (isScrolledIntoView2(this) === true) {
            $(this).addClass('active');
        } else {
          $(this).removeClass('active');
        }
    });
});





/* 01/07/2025 */
$(document).on("click", ".custom_select_patterns_item", function(e) {
var current_tab = $(this).attr('current_tab');
$('.custom_popup').show();
$('.trigger_pattern_count').attr('current_tab',current_tab);
$('.pattern_top_flex h2 span').text(current_tab);
});




$(document).on("click", ".custom_popup_bg,.close_popup", function(e) {
$('.custom_popup').hide();
});







$(document).on("click", ".popup_product_flex_item:not(.active)", function(e) {
$('.custom_select_patterns_item').removeClass('free_product_lp');
var currency_symbol = $('.custom_popup').attr('currency');
var current_tab = $(this).parents('.trigger_pattern_count').attr('current_tab');
$('.popup_product_flex_item.active[active_tab="'+current_tab+'"]').removeClass('active');
$('.popup_product_flex_item.active[active_tab="'+current_tab+'"]').attr('active_tab','');
$(this).addClass('active');
$(this).attr('active_tab',current_tab);
var variant_id = $(this).attr('variant_id');
var price = $(this).attr('price');
var image = $(this).find('img').attr('src');
var title = $(this).find('.popup_product_flex_item_title').text();
$('.custom_popup').hide();
var price_no = (price/100).toFixed(2);
var price_currency = currency_symbol+ price_no;
var target_pattern = $('.custom_select_patterns_item[current_tab="'+current_tab+'"]');
target_pattern.attr('variant_id',variant_id);
target_pattern.attr('price',price);
target_pattern.addClass('active');
target_pattern.find('.custom_select_patterns_item_locked img').attr('src',image);
target_pattern.find('.custom_select_patterns_item_locked p.title').text(title);
target_pattern.find('.custom_select_patterns_item_locked p.price').text(price_currency);

var variant_id = $(this).attr('upsell_product_id');
var price = $(this).attr('upsell_price');
var image = $(this).attr('upsell_image');
var title = $(this).attr('upsell_title'); 
var target_pattern = $('.custom_select_patterns_item_upsell[current_tab="'+current_tab+'"]');
var price_no = (price/100).toFixed(2);
var price_currency = currency_symbol+ price_no;
target_pattern.attr('variant_id',variant_id);
target_pattern.attr('price',price);
target_pattern.addClass('active');
target_pattern.removeClass('added');
target_pattern.find('.custom_select_patterns_item_upsell_locked img').attr('src',image);
target_pattern.find('.custom_select_patterns_item_upsell_locked p.title').text(title);
target_pattern.find('.custom_select_patterns_item_upsell_locked p.price').text(price_currency);
update_price();
});


$(document).on("click", ".delete_pattern", function(e) {
$('.custom_select_patterns_item').removeClass('free_product_lp');
var current_tab = $(this).parents('.custom_popup').attr('current_tab');
$(this).parents('.custom_popup').find('.popup_product_flex_item[active_tab="'+current_tab+'"]').attr('active_tab','').removeClass('active');
$('.custom_popup').hide();
var target_pattern = $('.custom_select_patterns_item[current_tab="'+current_tab+'"]');
target_pattern.attr('variant_id','');
target_pattern.attr('price','');
target_pattern.removeClass('active');
target_pattern.find('.custom_select_patterns_item_locked img').attr('src','');
target_pattern.find('.custom_select_patterns_item_locked p.title').text('');
target_pattern.find('.custom_select_patterns_item_locked p.price').text('');
var target_pattern2 = $('.custom_select_patterns_item_upsell[current_tab="'+current_tab+'"]');
target_pattern2.attr('variant_id','');
target_pattern2.attr('price','');
target_pattern2.removeClass('active').removeClass('added');
target_pattern2.find('.custom_select_patterns_item_upsell_locked img').attr('src','');
target_pattern2.find('.custom_select_patterns_item_upsell_locked p.title').text('');
target_pattern2.find('.custom_select_patterns_item_upsell_locked p.price').text('');
  
update_price();
});

 

function update_price() {
var total_price = 0;
$('.custom_select_patterns_item.active').each(function(){
var price = parseFloat($(this).attr('price'));
total_price = total_price+price;
});
var active_patterns = $('.custom_select_patterns_item.active').length;
if (active_patterns>3 ){
var price_array = ','
$('.custom_select_patterns_item.active').each(function(){
var price = parseFloat($(this).attr('price'));
price_array = price_array+','+price;
});

$('.custom_select_patterns_item_upsell.active.added').each(function(){
var price = parseFloat($(this).attr('price'));
total_price = total_price+price;
});
var orignal_total_price = total_price;
price_array = price_array.replace(",,", "");
price_array = price_array.split(",");
price_array = price_array.sort(function (a, b) { return a - b });
var lowest_price = price_array[0];
$('.custom_select_patterns_item').removeClass('free_product_lp');
$('.custom_select_patterns_item[price="'+lowest_price+'"]:not(.free_product_lp)').eq(0).addClass('free_product_lp');
var total_price =total_price-lowest_price;
} else {
$('.custom_select_patterns2 .custom_select_patterns_item.active').each(function(){
var current_tab = $(this).attr('current_tab');
$('.custom_popup').find('.popup_product_flex_item[active_tab="'+current_tab+'"]').attr('active_tab','').removeClass('active');
$(this).attr('variant_id','');
$(this).attr('price','');
$(this).removeClass('active');
$(this).find('.custom_select_patterns_item_locked img').attr('src','');
$(this).find('.custom_select_patterns_item_locked p').text('');
});
var total_price = 0;
$('.custom_select_patterns_item.active').each(function(){
var price = parseFloat($(this).attr('price'));
total_price = total_price+price;
});

$('.custom_select_patterns_item_upsell.active.added').each(function(){
var price = parseFloat($(this).attr('price'));
total_price = total_price+price;
});
}


  
var currency_symbol = $('.custom_popup').attr('currency');
var price_string = total_price/100;
var price_currency = currency_symbol+ price_string;
var orignal_price_string = orignal_total_price/100;
var orignal_price_currency = currency_symbol+ orignal_price_string;
if(total_price > 0){
$('.new_price_trigger').text(price_currency).show();  
$('.old_price_trigger').hide(); 
$('.custom_checkout_button').removeAttr('disabled');
} else {
$('.new_price_trigger').text('').hide();  
$('.old_price_trigger').show(); 
$('.custom_checkout_button').attr('disabled','disabled');
}
$('.custom_select_patterns').attr('active_patterns',active_patterns);
$('.custom_select_box_heading').hide();
if (active_patterns==4 ){
$('.new_price_trigger').html(price_currency+'<s>'+orignal_price_currency+'</s>');  
$('.custom_select_box_heading[data_tab="5"]').show();
$('.custom_select_progress_bar_fill').css('width','100%');
} else if (active_patterns==3 ){
$('.custom_select_box_heading[data_tab="4"]').show();
$('.custom_select_progress_bar_fill').css('width','75%');
}else if (active_patterns==2 ){
$('.custom_select_box_heading[data_tab="3"]').show();
$('.custom_select_progress_bar_fill').css('width','50%');
}else if (active_patterns==1 ){
$('.custom_select_box_heading[data_tab="2"]').show();
$('.custom_select_progress_bar_fill').css('width','25%');
}else if (active_patterns==0 ){
$('.custom_select_box_heading[data_tab="1"]').show();
$('.custom_select_progress_bar_fill').css('width','0%');
}
}



$(document).on("click", ".add_custom_ajax_upsell", function (e) {
jQuery(this).parents('.custom_select_patterns_item_upsell').addClass('added');
update_price();
});

$(document).on("click", ".remove_custom_ajax_upsell", function (e) {
jQuery(this).parents('.custom_select_patterns_item_upsell').removeClass('added');
update_price();
});
